<template>
  <div @click="expandCart(false)" class="cart-container" :class="[expanded == true ? 'expanded' : '']">
      <div @touchstart="dragStart" @touchend="dragEnd" v-on:click.stop class="unexpanded-cart" v-if="expanded == false">
            <div class="product-preview-container">
                <div class="products-container">
                    <div v-for="addonProduct in cartProducts" :key="addonProduct.variants[0].id" class="addon-container">
                        <img class="main-image" :src="getProductImage(addonProduct)">
                        <p class="floating-qty">{{addonProduct.quantity}}</p>
                    </div>
                </div>
            </div>
            <div class="buttons-container">
                <button @click="expandCart(true)" class="happybox-button white border">Preview Box</button>
                <button @click="changePage(true)" class="happybox-button green border">Next ></button>
            </div>
        </div>
      <div v-on:click.stop class="expanded-cart">
            <div @touchstart="dragStart" @touchend="dragEnd" class="expanded-cart-header">
                <p @click="expandCart(false)" class="close-alert">&lt; Keep Shopping</p>
                <p v-tooltip="{content: boxAlert, show: showBoxAlert, trigger: ['manual']}" class="box-name" v-if="isEditingName == false">{{boxName}}</p>
                <button class="box-name-legend" @click="editName(true)" v-if="!isEditingName"> <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/icon.png?v=1658429893"/></button>
                <input v-on:keyup.enter="editName(false)" @blur="checkName()" v-if="isEditingName" type="text" maxlength="34" v-model="boxName">
            </div>
            <div class="product-summary-container no-scrollbar">
                <div class="product-summary">
                    <p class="summary-title">Box Contents</p>
                    <p class="summary-text">Boxes look best with 4-6 products</p>
                    <p class="summary-subtitle" v-if="totalQtyProducts < 4">Add a few more items to make your box full</p>
                    <ul class="products-container">
                        <li v-for="addonProduct in cartProducts" :key="addonProduct.variants[0].id">
                            <div class="addon-container">
                                <div class="image-container">
                                    <img @click="openModalProduct(addonProduct)" class="main-image" :src="getProductImage(addonProduct)"/>
                                </div>
                                <div class="product-information">
                                    <div>
                                        <p class="title">{{addonProduct.title}}</p>
                                    </div>
                                    <div class="product-data-container">
                                        <p class="price">{{addonProduct | moneyFormat}}</p>
                                        <div class="product-qty-container">
                                        <select v-model="addonProduct.quantity" @change="changeOnDemand(addonProduct)">
                                            <option v-for="qty in addonMaxQty(addonProduct)" :key="qty" :value="qty">{{qty}}</option>
                                        </select>
                                        <img @click="removeProduct(addonProduct)" class="delete-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/trash_05a3e1b5-b394-4f91-aaf3-599964c057cb.svg?v=1659632833">
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <button @click="removeAll()" class="remove-all">Remove All</button>
                </div>
                <div class="box-container">
                    <div class="box-qty-container">
                        <p>Box Quantity</p>
                        <div class="box-qty-input-container">
                            <button :disabled="selectedBoxQty == 1" @click="incrementBoxQty(false)">-</button> 
                            <input @blur="changeBoxQty(null)" v-model="selectedBoxQty" type="number" min="1"> 
                            <button @click="incrementBoxQty(true)">+</button>
                        </div>
                    </div>
                    <p class="multiship-notice">Adjust the quantity if you'd like duplicates of this box, even if you're shipping to different addresses!</p>
                    <p class="custom-notice" v-if="customAlert">{{customAlert}}</p>
                </div>
                <div class="summary-container">
                    <div class="item-summary">
                        <p class="item-title">Box Summary</p>
                        <div class="box-total">
                            <div class="total-container">
                                <p v-if="boxQty > 1" class="title"><strong>({{boxQty}})</strong> {{boxName}}</p>
                                <p v-else class="title">{{boxName}}</p>
                                <p class="price">{{ totalPrice * boxQty | moneySaleFormat}}</p>
                            </div>
                            <p class="individual-price">{{totalPrice | moneySaleFormat}} per box</p>
                        </div>
                        <div class="box-total">
                            <div class="total-container">
                                <p class="title">Gift Box Design (selected at next step)</p>
                                <p class="price">$--</p>
                            </div>
                        </div>
                        <div class="box-total">
                            <div class="total-container">
                                <p class="title">Card (selected at future step)</p>
                                <p class="price">$--</p>
                            </div>
                        </div>
                        <div class="box-total">
                            <p class="purple-legend" v-if="hasOnDemandProducts"> Some items in your cart may  require 1-2 week lead time.  But trust us, they're worth the wait!</p>
                            <p v-else-if="hasCustomProducts" class="individual-price">Custom items require a lead time of at least 1-2 weeks. Our team will reach out via email to coordinate shipping details.</p>
                        </div>
                        <div class="item-total">
                            <p class="title">Item Total</p>
                            <p class="price">{{ (totalPrice * boxQty) | moneySaleFormat}}</p>
                        </div>
                    </div>
                    <div class="taxes-container">
                        <p class="title">Taxes <strong>(calculated in checkout)</strong></p>
                        <p class="price">--</p>
                    </div>
                    <div class="separator"></div>
                    <div class="subtotal-container">
                        <p class="title">Estimated Subtotal</p>
                        <p class="price">{{ (totalPrice * boxQty) | moneySaleFormat}}</p>
                    </div>
                </div>
                <div v-if="recommendedAddons.length > 0" class="recommendation-container">
                    <p class="title">Perfect fit for your box</p>
                    <div class="recommended-addon-container no-scrollbar">
                        <div class="recommended-addon" v-for="addon in recommendedAddons" :key="addon.id">
                            <img @click="openModalProduct(addon)" :src="addon.image.src" class="main-image">
                            <button @click="updateReccomendedAddonProductQuantity(addon)" class="happybox-button white border">{{ addCopy }}</button>
                            <p class="addon-title">{{addon.title}}</p>
                            <p class="price">{{addon.variants[0].price | moneySaleFormat}}</p>
                        </div>
                    </div>
                </div>
                <VueSlickCarousel :infinite="true" :dots="true" :arrows="true" :slidesToShow="1" :slidesToScroll="1">
                    <template #prevArrow="arrowOption">
                        <div>
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_left.svg?v=1657408648">
                        </div>
                    </template>
                    <div v-if="hasOnDemandProducts" class="notice-container">
                        <img class="main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/box.svg?v=1658459692"/>
                        <div>
                            <p class="title">Items may take up to ~2 weeks to ship</p>
                            <p class="subtitle">All boxes are made to order, <br/> just for you!</p>
                        </div>
                    </div>
                    <div v-else class="notice-container">
                        <img class="main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/box.svg?v=1658459692"/>
                        <div>
                            <p class="title">We hand-pack your items!</p>
                            <p class="subtitle">Our team will ensure your box <br/> feels full and is packed perfectly!</p>
                        </div>
                    </div>
                    <div class="notice-container">
                        <img class="main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/boxwings.svg?v=1658459692"/>
                        <div>
                            <p class="title">Multiple addresses? No problem!</p>
                            <p class="subtitle">Ship to one or many locations all <br/> in one, easy checkout</p>
                        </div>
                    </div>
                    <template #nextArrow="arrowOption">
                        <div>
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_right.svg?v=1657408648">
                        </div>
                    </template>
                </VueSlickCarousel>
          </div>
          <div class="complete-box">
              <button @click="changePage(true)" class="happybox-button green border">Next ></button>
          </div>
      </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { mapGetters } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel'
import smoothReflow from 'vue-smooth-reflow'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
    mixins: [smoothReflow],
    props: {
        cartProducts: Array,
        recommendedAddons: Array
    },
    components: {
        VueSlickCarousel,
    },
    data() {
      return {
        expanded: false,
        selectedBoxQty: 1,
        startingY: 0,
        isEditingName: false,
        boxAlert: "",
        showBoxAlert: false,
      }
    },
    watch: {
        boxQty: {
            handler(val){
                this.selectedBoxQty = val;
            },
            deep: true
        },
    },
    computed:{
        ...mapGetters([
          'maxCapacity',
          'currentCapacity',
          'productLimit',
          'boxProducts',
          'defaulBoxName',
          'cartNames',
          'feeProduct',
          'cardProducts',
          'customData',
          'addonProducts',
          'addCopy',
        ]),
        totalPrice(){
            if(this.cartProducts.length > 0){
               return this.cartProducts.map(x => x.variants.length ? parseFloat(x.variants[0].price * x.quantity) : 0)
                .reduce((prev, next) => prev + next, 0);
            }

            return "0"
        },
        shippingPrice(){
            return 12
        },
        boxQty: {
            get(){ return this.$store.state.boxQty},
            set(value){this.$store.commit('setBoxQty', value )}
        },
        boxName: {
            get(){ return this.$store.state.boxName},
            set(value){this.$store.commit('setBoxName', value )}
        },
        leftOverCapacity(){
            return this.maxCapacity - this.currentCapacity;
        },
        totalQtyProducts(){
            return this.cartProducts.map(x => x.quantity).reduce((prev, next) => prev + next, 0);
        },
        canAddMore(){
            var canAddArray = this.cartProducts.every((x) =>{
                return ((this.boxQty + 1) * x.quantity) <= this.productCurrentVariantInventory(x)
            })

            return canAddArray
        },
        boxPrice(){
            if(this.boxProducts.length > 0){
                return this.boxProducts[0].variants[0].price;
            }

            return 0
        },
        cardPrice(){
            if(this.cardProducts.length > 0){
                return this.cardProducts[0].variants[0].price;
            }

            return 0
        },
        feePrice(){
            if(this.feeProduct){
                let price = (this.feeProduct.variants[0].price / 100).toFixed(2);
                return price;
            }

            return 0
        },
        hasCustomProducts(){
            return this.cartProducts.some(x => x.tags.some(y => y.includes("Customizable")))
        },
        hasOnDemandProducts(){
            return this.cartProducts.some(x => x.variants[0].sku.toLowerCase().includes("ondemand"))
        },
        customAlert(){
            let productList = this.cartProducts.filter(x => x.tags.some(x => x.includes("QTYMIN") && !x.includes("DEMAND")));
            if(productList.length > 0){
                var productTitles = productList.map(x => x.title);
                let minQtys = productList.map((x) =>{
                    let minTag = x.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
                    if(minTag){
                        minTag = minTag.split("_");
                        minTag = minTag[minTag.length - 1];
                        return minTag;
                    }

                    return 1
                })
                let maxQty = Math.max([...minQtys])
                return `Please note: "${productTitles.join(", ")}" requires a minimum of ${maxQty} units to be included in your boxes. If you lower your box quantity below this amount, this item will be removed`
            }

            return null
        }
    },
    methods:{
        removeProduct(product){
            this.$store.commit('removeSelectedAddonProductNew', product);
        },
        editName(edit){
            this.isEditingName = edit;
        },
        expandCart(expand){
            this.expanded = expand;
        },
        incrementBoxQty(increment){
            if(increment){
                this.changeBoxQty(this.boxQty + 1)
            }
            else {
                if(this.boxQty > 1){
                    this.changeBoxQty(this.boxQty - 1)
                }
            }
        },
        addonMaxQty(addon){
            const min = 1,
            max = this.getProductMaxQty(addon),
            interval = 1;
            const length = (max - min) / interval + 1;
            let arr = Array.from({ length }, (_, i) => min + i * interval);

            if(this.demandQtyMin(addon) > 0){
                arr = this.checkOnDemandArray(arr,addon);
            }

            return arr;
        },
        getProductMaxQty(addon){
            //Get max value posible in products, no more than the product limit per box
            var maxValues = [this.productLimit]
            //Get limit based on inventory * total boxes
            let inventoryQty = this.productCurrentVariantInventory(addon)
            maxValues.push(Math.floor( inventoryQty / this.boxQty));
            //Get limit based on currentCapacity
            let maxPerCapacity = Math.max(...[Math.floor((this.maxCapacity - this.currentCapacity) / addon.capacity + this.getProductCurrentQty(addon)),this.getProductCurrentQty(addon)])
            maxValues.push(maxPerCapacity);

            return Math.min(...maxValues)
        },
        getProductCurrentQty(currentProduct){
          var product = this.cartProducts.find(x => x.id == currentProduct.id);
          if(product)
            return product.quantity
          return 0
        },
        updateReccomendedAddonProductQuantity(product){
            var productQty = this.getProductCurrentQty(product) + 1;
            this.$store.commit('updateSelectedAddonProductsNew',{product: product, quantity: productQty});
        },
        changePage(increment){
            this.$emit("changepage", increment);
        },
        changeBoxQty(qty){
            //Validate if cart products can support box qty if not show alert
            this.selectedBoxQty = qty ? qty : parseInt(this.selectedBoxQty);
            var canUpdate = this.cartProducts.filter((x) =>{
                let demandQty = this.demandQtyMin(x);
                if(demandQty >= this.selectedBoxQty)
                    return false
                if((this.selectedBoxQty * (x.quantity)) > this.productCurrentVariantInventory(x) )
                    return true

                return false
            })

            let customizableUpdate = this.cartProducts.filter((x) =>{
                if(x.tags.some(x => x.includes("QTYMIN") && !x.includes("DEMAND"))){
                    let minTag = x.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
                    if(minTag){
                        minTag = minTag.split("_");
                        minTag = minTag[minTag.length - 1];
                        if(this.selectedBoxQty < parseInt(minTag)){
                            return true;
                        }
                    }
                }

                return false
            })

            let ondemandUpdate = this.cartProducts.filter((x) =>{
                let demandQty = this.demandQtyMin(x);
                if(demandQty > 0){
                    let product = this.addonProducts.find(y => y.id == x.id);
                    let notDemand = product.variants.find(y => !y.sku.toLowerCase().includes("ondemand"));
                    if(this.selectedBoxQty * x.quantity < demandQty && notDemand.inventory_quantity < this.selectedBoxQty * x.quantity){
                        return true;
                    }
                }

                return false
            })

            if(customizableUpdate.length > 0){
                this.openBoxQtyCustomConfirmation(customizableUpdate);
            }
            else if(ondemandUpdate.length > 0){
                this.openBoxQtyOnDemandConfirmation(ondemandUpdate);
            }
            else if(canUpdate.length > 0){
                this.openBoxQtyConfirmation(canUpdate);
            }
            else {
                this.boxQty = this.selectedBoxQty;
                this.checkOnDemand();
            }
        },
        openBoxQtyConfirmation(productList){
            var productTitles = productList.map(x => x.title);
            const alertText = "The following products dont have enough inventory to match the number of boxes: " + productTitles.join(", ") + ". Do you want to remove them?";
            Swal.fire({
                title: 'Are you sure?',
                text: alertText,
                showCancelButton: true,
                confirmButtonText: 'Yes, delete them!',
                cancelButtonText: 'No, cancel!',
                reverseButtons: true,
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                    cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.boxQty = this.selectedBoxQty
                    this.checkOnDemand();
                } else if ( result.dismiss === Swal.DismissReason.cancel )
                {
                    this.selectedBoxQty = this.boxQty;
                }
                else{
                    this.selectedBoxQty = this.boxQty;
                }
            })
        },
        openBoxQtyOnDemandConfirmation(productList){
            var productTitles = productList.map(x => x.title);
            let minQtys = productList.map((x) =>{
                let minTag = x.tags.find(x => x.includes("DEMAND_QTYMIN"));
                if(minTag){
                    minTag = minTag.split("_");
                    minTag = minTag[minTag.length - 1];
                    return minTag;
                }

                return 1
            })
            let maxQty = Math.max([...minQtys])
            const alertText = `Please note: "${productTitles.join(", ")}" requires a minimum of ${maxQty} units to be included in your boxes. If you lower your box quantity below this amount, this item will be removed`
            Swal.fire({
                title: 'Are you sure?',
                text: alertText,
                showCancelButton: true,
                confirmButtonText: 'Yes, delete them!',
                cancelButtonText: 'No, cancel!',
                reverseButtons: true,
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                    cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.changeBoxQty();
                } else if ( result.dismiss === Swal.DismissReason.cancel )
                {
                    this.selectedBoxQty = this.boxQty;
                }
                else{
                    this.selectedBoxQty = this.boxQty;
                }
            })
        },
        openBoxQtyCustomConfirmation(productList){
            const alertText = this.customAlert;
            Swal.fire({
                title: 'Are you sure?',
                text: alertText,
                showCancelButton: true,
                confirmButtonText: 'Yes, delete them!',
                cancelButtonText: 'No, cancel!',
                reverseButtons: true,
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                    cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.changeBoxQty();
                } else if ( result.dismiss === Swal.DismissReason.cancel )
                {
                    this.selectedBoxQty = this.boxQty;
                }
                else{
                    this.selectedBoxQty = this.boxQty;
                }
            })
        },
        dragStart(event){
            this.startingY = event.touches[0].screenY;
        },
        dragEnd(event){
            if((event.changedTouches[0].screenY - this.startingY) < -100)
                this.expandCart(true);
            else if ((event.changedTouches[0].screenY - this.startingY) > 100)
                this.expandCart(false);
        },
        checkName(){
            if(this.boxName == ""){
                this.boxAlert = "Box name cannot be empty";
                this.showBoxAlert = true;
                this.boxName = this.defaulBoxName;
            }
            else if (this.cartNames.includes(this.boxName)){
                this.boxAlert = "Another box has the same name"
                this.showBoxAlert = true;
                this.boxName = this.defaulBoxName;
            }
            else {
                this.boxAlert = ""
                this.showBoxAlert = false;
            }
            let that = this;
            setTimeout(() => {that.showBoxAlert = false;}, 2000);
            this.isEditingName = false;
        },
        removeAll(){
            this.$store.commit('updateAllSelectedAddonProducts', []);
            this.expandCart(false);
        },
        openModalProduct(product){
            this.$emit("openmodal",product);
            this.expandCart(false);
        },
        getProductImage(product){            
            return (product.images.length > 0) ? product.images[product.images.length - 1].src : ''
            
        },
        isOnDemand(addon){
            let product = this.addonProducts.find(x => x.id == addon.id);
            return product.variants.some(x => x.sku.toLowerCase().includes("ondemand"));
        },
        productCurrentVariantInventory(product){
            if(this.isOnDemand(product))
                return 9999;
            return product.variants[0].inventory_quantity;
        },
        changeOnDemand(addonProduct){
            if(this.isOnDemand(addonProduct)){
                let product = this.addonProducts.find(x => x.id == addonProduct.id);
                var variantProduct = JSON.parse(JSON.stringify(product));
                let notDemand = variantProduct.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
                let onDemand = variantProduct.variants.find(x => x.sku.toLowerCase().includes("ondemand"));
                if(notDemand.inventory_quantity >= addonProduct.quantity * this.boxQty  || this.demandQtyMin(addonProduct) > this.boxQty * addonProduct.quantity){
                    variantProduct.variants = [notDemand];
                }
                else 
                    variantProduct.variants = [onDemand];

                if(addonProduct.variants[0].id != variantProduct.variants[0].id){
                    this.$store.commit('updateSelectedAddonProductsNew',{product: addonProduct, quantity: 0});
                    this.$store.commit('updateSelectedAddonProductsNew',{product: variantProduct, quantity: addonProduct.quantity});
                }
            }
        },
        checkOnDemand(){
            let cartIds = this.cartProducts.map(x => x.id);
            let onDemandProducts = this.addonProducts.filter(x => cartIds.includes(x.id) && x.variants.some(y => y.sku.toLowerCase().includes("ondemand")));
            if(onDemandProducts.length > 0){
                let ondemandIds = onDemandProducts.map(x => x.id);
                let ondemandCartProducts = this.cartProducts.filter(x => ondemandIds.includes(x.id));
                for(let addon of ondemandCartProducts){
                    this.changeOnDemand(addon)
                }
            }
        },
        demandQtyMin(addon){
            let demandQtymin = addon.tags.find(x => x.includes("DEMAND_QTYMIN"));
            if(demandQtymin){
                if(demandQtymin){
                    demandQtymin = demandQtymin.split("_");
                    demandQtymin = demandQtymin[demandQtymin.length - 1];

                    return  parseInt(demandQtymin);
                }
            }

            return 0;
        },
        checkOnDemandArray(arr,addon){
            let demandMinQty = this.demandQtyMin(addon);
            let product = this.addonProducts.find(x => x.id == addon.id);
            const notDemand = product.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
            const notDemandInventory = notDemand.inventory_quantity;
            for(let int of arr){
                if((int * this.boxQty) < demandMinQty && (int * this.boxQty) > notDemandInventory)
                arr.splice(int-1,1);
            }

            return arr;
        },
    },
    mounted() {
        this.$smoothReflow({
            property: ['height'],
            transition: 'height 1s'
        });
        this.selectedBoxQty = this.boxQty;
    }
}
</script>

<style lang="scss" scoped>

.cart-container{
    position: fixed;
    bottom: 0%;
    width: 100%;
    height: 0%;
    background-color: rgba(0, 0, 0, 0.2);
    box-shadow: inset 0px 1px 0px #E6E8EC;
    left: 0%;
    right: 0%;
    display: flex;
    padding-top: unset;
    align-items: flex-end;
    z-index: 4;
}

.cart-container.expanded{
    height: 100%;
}
//Unexpanded cart css
.unexpanded-cart{
    width: 100%;
    box-shadow: 0px -18px 8px rgba(31, 41, 55, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    bottom: 0;
    height: auto;
    background-color: white;
}

.unexpanded-cart .happybox-button{
    flex: 1;
    padding: 1%;
}

.unexpanded-cart .buttons-container{
    width: 100%;
    display: flex;
    align-items: center;
    gap: 5%;
    padding: 2%;
}

.product-preview-container{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.unexpanded-cart .products-container{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow-x: scroll;
}

.unexpanded-cart .addon-container{
    width: 15%;
    position: relative;
    padding: 3% 3% 0%;
    flex-shrink: 0;
}

.unexpanded-cart .addon-container .main-image{
    border: unset;
    background-color: #F3F4F6;
    width: 100%;
}

.unexpanded-cart .addon-container .floating-qty{
    position: absolute;
    top: 0.5rem;
    right: 0rem;
    background-color: #fff;
    border: 1px solid #9CA3AF;
    border-radius: 100px;
    font-size: 1rem;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-box{
    color: #0F0C38;
    font-weight: 700;
    font-size: 1.2rem;
    line-height: 1;
    text-align: right;
    padding: 2% 5%;
    position: absolute;
    right: 0;
    top: -2.35rem;
    background-color: white;
    border-radius: 20px 20px 0 0;
    box-shadow: 0px -8px 8px rgba(31, 41, 55, 0.1);
}

.addon-container select{
    width: 50%;
    background-color: #FFFFFF;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
    padding: 0% 0% 0% 10%;
    height: unset;
    margin-right: 10%;
}
.delete-button{
    width: 30%;
    background: #FFFFFF;
    border-radius: 4px;
}

//Expanded Cart Css
.expanded-cart{
    width: 100%;
    height: 85%;
    background-color: white;
    display: flex;
    flex-direction: column;
    border-radius: 16px 16px 0px 0px;
    position: absolute;
    bottom: 0;
    overflow-y: scroll;
}

.expanded-cart .close-alert{
    letter-spacing: 0;
    font-size: 3.5vw;
    left: 2%;
    font-family: karla;
    font-weight: bold;
    width: 30%;
    margin-right: 10%;
    color: #66498c;
}

.product-summary-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0% 2%;
    overflow-y: scroll;
}

.product-summary{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border: 1px solid #E8E1F2;
    box-sizing: border-box;
    border-radius: 4px;
    margin-top: 5%;
    padding: 2%;
}

.summary-title{
    color:#0F0C38;
    font-size: 1.2rem;
    line-height: 1.5;
    font-weight: bold;
}

.summary-text{
    color:#0F0C38;
    font-size: 1rem;
    line-break: 1.43;
}

.expanded-cart .products-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    list-style: none;
    justify-content: space-between;
    margin: unset;
    padding: 5% 2%;
}


.expanded-cart .products-container li{
    width: 100%;
}

.expanded-cart .addon-container{
    width: 100%;
    display: flex;
}

.expanded-cart .addon-container .image-container{
    width: 20%;
}

.expanded-cart .addon-container .main-image{
    width: 100%;
    background-color: #f6f6f6;
}

.expanded-cart .product-information{
    width: 80%;
    display: flex;
    flex-direction: column;
    padding-left: 5%;
    justify-content: space-between;
}

.expanded-cart .product-information .product-data-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.expanded-cart .product-information .title{
    line-height: 1.43;
    font-size: 1rem;
    font-weight: bold;
}

.expanded-cart .product-information .price{
    line-height: 1.43;
    font-size: 1rem;
}

.product-qty-container{
    width: 50%;
    display: flex;
}

.product-qty-container select{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7 !important;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px !important;
    height: unset !important;
    padding: 1% 2% !important;
    text-align: center;
    font-size: 1.1rem;
    width: 70% !important;
    line-height: 1.5;
    -moz-appearance: textfield;
}

.product-qty-container .delete-button{
    width: 20%;
}

.box-container{
    background-color: #F9FAFB;
    margin-top: 5%;
    padding: 0% 2% 2% 2%;
}

.box-qty-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3% 0%;
}
.box-qty-container p{
    font-weight: 700;
    font-size: 1.2rem;
    line-height: 1.5;
    color: #0F0C38;
}


.box-qty-input-container{
    width: 50%;
    display: flex;
    justify-content: flex-end;
}

.box-qty-input-container input{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7 !important;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px !important;
    height: unset !important;
    text-align: center;
    font-size: 1.2rem;
    width: 30% !important;
    line-height: 1.5;
    -moz-appearance: textfield;
    font-weight: 700;
    color: #0F0C38;
}

.box-qty-input-container input::-webkit-inner-spin-button,
.box-qty-input-container input::-webkit-outer-spin-button{
   -webkit-appearance: none;
    margin: 0;
}

.box-qty-input-container button{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    padding: 0% 1.2rem;
    margin: 0% 5%;
    color: #0F0C38;
}

.box-qty-input-container button:disabled{
    background-color: lightgray;
    opacity: 0.6;
}

.multiship-notice{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.43;
    color: #0F0C38;
}

.custom-notice{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5;
    color: #581C87;
    margin-top: 5%;
}

.recommendation-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 5% 0%;
}

.recommendation-container .title{
    width: 100%;
    width: 100%;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.6;
    color: #0F0C38;
    padding-bottom: 2%;
}

.recommended-addon-container{
    width: 100%;
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
}

.recommended-addon{
    width: 40%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    margin-right: 5%;
}

.recommended-addon .main-image{
    width: 100%;
    margin-bottom: 5%;
}

.recommended-addon .addon-title{
    font-weight: 700;
    color: #0F0C38;
    line-height: 1.2;
    font-size: 1rem;
    margin-top: 5%;
}

.expanded-cart .happybox-button.white{
    padding: 3% 0%;
}

.complete-box{
    position: sticky;
    bottom: 0%;
    box-shadow: inset 0px 1px 0px #e6e8ec;
    left: 0%;
    width: 100%;
    width: 100%;
    background-color: white;
}

.complete-box .happybox-button{
    width: 90%;
    margin: 3% 0% 3% 5%;
}

.expanded-cart-header{
    position: sticky;
    top: 0%;
    background-color: white;
    padding: 2%;
    box-shadow: inset 0px -1px 0px #e6e8ec;
    border-radius: 16px 16px 0px 0px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.expanded-cart-header p{
    font-family: ff-more-web-pro-condensed,Karla,sans-serif;
    font-size: 6vw;
    line-height: 1.23;
    text-align: center;
    letter-spacing: 0.03em;
    color: #0F0C38;
}

.expanded-cart-header .input{
    font-size: 16px;
}

.box-name-legend{
    display: flex;
    align-items: center;
    padding-left: 3%;
}

.product-summary .remove-all{
    text-align: right;
    color: #66498c;
    font-size: 3.5vw;
}

.remove-all:hover{
    text-decoration: underline;
}
.item-summary{
        border-top: 1px solid #D1D5DB;
        padding: 3% 0%;
    }

    .item-title{
        font-family: ff-more-web-pro-condensed,Karla,sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 6vw;
        line-height: 1.5;
        color: #0F0C38;
        margin-bottom: 2%;
    }

    .summary-container{
        padding: 0% 5%;
    }

    .subtotal-container,.taxes-container{
        display: flex;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: #0F0C38;
        font-family: 'Karla';
        font-style: normal;
        font-weight: 700;
    }

    .subtotal-container p,.taxes-container p{
        margin: unset;
    }

    .subtotal-container{
        font-size: 4.2vw;
        line-height: 1.6;
        padding-bottom: 5%;
    }

    .taxes-container{
        font-size: 3.5vw;
        line-height: 150%;
        border-top: 1px solid #D1D5DB;
        padding-top: 3%;
    }

    .taxes-container strong{
        font-weight: 400;
    }

    .box-total{
        width: 100%;
        font-weight: 400;
        font-size: 3.5vw;
        line-height: 1.4;
        color: #0F0C38;
        margin-bottom: 3%;
    }

    .box-total p,.item-total p{
        margin: unset;
    }

    .total-container{
        display: flex;
        justify-content: space-between;
    }

    .individual-price{
        font-style: italic;
    }

    .item-total{
        display: flex;
        justify-content: space-between;
        width: 100%;
        font-weight: 700;
        font-size: 3.5vw;
        line-height: 150%;
        color: #0F0C38;
    }

    .total-container .service-fee{
        color: #5048E5;
    }

    .blue-legend{
        font-family: 'Karla';
        font-size: 3vw;
        line-height: 1.43;
        color: #5048E5;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .blue-legend img{
        width: 3%;
        margin-right: 2%;
    }

    .purple-legend{
        font-family: 'Karla';
        font-size: 3vw;
        line-height: 1.43;
        color: #66498c;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .notice-container{
    background: white;
    border: 1px solid #F5EEFE;
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
    padding: 4%;
    margin: 2% 0%;
    display: flex !important;
}

.notice-container .title{
    font-size: 3.5vw;
    font-weight: bold;
    line-height: 1.5;
}

.notice-container .subtitle{
    font-size: 3.5vw;
    line-height: 1.5;
}

.notice-container .main-image {
    width: 20%;
    padding: 1%;
    margin-right: 5%;
}

.slick-slider,.slick-list{
    width: 100%;
}

.slick-slide > div:first-child

.slick-prev:before, .slick-next:before{
    content: none !important;
}

.slick-arrow{
    width: 8vw;
    z-index: 1; 
}

.slick-prev{
    left: 0px;
} 
.slick-next{
    right: 0px;
}

.slick-arrow img{
    width: 100%;
}
</style>